<template>
  <div class="register-progress">
    <div class="progress registration-progress">
      <div class="progress-bar" id="registration-progress" role="progressbar" :style="{width: `${progress}%`}" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">
        <div class="indicator">
          Registration status
          <br />
          <span>{{ progress }}%</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'

export default {
  name: 'register-progress',
  computed: {
    ...mapFields({
      progress: 'registration.progress',
      user: 'user',
      company: 'company',
      bank: 'bank',
      paymentAcceptance: 'paymentAcceptance',
      services: 'services'
    })
  },
  mounted() {
    this.calculateStatus()
    this.$store.watch(
      () => this.$store.state,
      () => this.calculateStatus(),
      {
        deep: true
      }
    )
  },
  methods: {
    calculateStatus() {
      let filled = 0
      const fields = Object.keys(this.user).length - 2 + Object.keys(this.company).length + Object.keys(this.bank).length - 2 + 4

      Object.keys(this.user).forEach(key => {
        if (this.user[key] && key !== 'phoneVerified' && key !== 'password') {
          filled++
        }
      })

      Object.keys(this.company).forEach(key => {
        if (this.company[key]) {
          filled++
        }
      })

      Object.keys(this.bank).forEach(key => {
        if (this.bank[key] && key !== 'shopCurrencies' && key !== 'transactionCurrencies') {
          filled++
        }
      })

      if (this.paymentAcceptance.filter(el => el.selected).length) {
        filled++
      }
      if (this.services.filter(el => el.selected).length) {
        filled++
      }

      const progress = Math.ceil((filled * 100) / fields)
      this.$store.commit('changeProgress', progress)
    }
  }
}
</script>
